import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";

import PennerRennerManagementSubTab from "./SubTabs/PennerRennerManagement";
import PennerRennerSheetSettingsSubTab from "./SubTabs/PennerRennerSheetSettings";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const PennerRennerTab = () => {
  const [pennerRennerSubTab, setPennerRennerSubTab] = useState(0);

  const handlePennerRennerSubTabChange = (event, newValue) => {
    setPennerRennerSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={pennerRennerSubTab}
              onChange={handlePennerRennerSubTabChange}
              aria-label="penner renner tabs"
            >
              <Tab label="Management" />
              <Tab label="Sheet Settings" />
            </Tabs>
          </Box>

          {/* Management Tab */}
          <TabPanel value={pennerRennerSubTab} index={0}>
            <PennerRennerManagementSubTab />
          </TabPanel>

          {/* Sheet Settings Tab */}
          <TabPanel value={pennerRennerSubTab} index={1}>
            <PennerRennerSheetSettingsSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PennerRennerTab;
